import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";

export default function UpdateServiceCharge({
  list,
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState();

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    console.log(event.target.value);
  };

  const token = localStorage.getItem("nodeToken");

  const update = async () => {
    setPopUp(false);
    setLoading(true);
    try {
      const response = await nodeinstance.post(
        url,
        {
          employeeId: list,
          newServiceCharge: inputValue,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.status);
      if (response.status === 200) {
        setLoading(false);
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );
        callBack();
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5 place-items-center">
              <div className="form-control w-full place-items-center">
                <h2 className="label place-items-center">{title}</h2>
              </div>

              <input
                className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
                onChange={(e) => handleInputChange(e)}
                type="number"
                step={"0.01"}
                required
                pattern="[0-9]*"
                min={10}
              />
              <div
                className="flex gap-3 w-full justify-center"
                style={{ margin: 2 }}
              >
                <button
                  onClick={() => update()}
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                >
                  {" "}
                  <p>Update Service Charge</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
